module.exports = __webpack_public_path__ + "static/media/DSC_0802.ca5b7627.JPG";